import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "@/shared/nav";
import { cn } from "@/shared/lib/cn";

/** 手机底栏：主路径 5 项 + 次要入口横滑 */
export function MobileNav() {
  const primary = NAV_ITEMS.filter((n) => n.mobile);
  const secondary = NAV_ITEMS.filter((n) => !n.mobile);

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-bg-elevated/95 backdrop-blur-sm md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex h-14 items-stretch">
        {primary.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "flex flex-1 flex-col items-center justify-center gap-0.5 text-[10px]",
                isActive ? "text-brand" : "text-fg-subtle",
              )
            }
          >
            <Icon className="size-4" strokeWidth={1.75} />
            {label}
          </NavLink>
        ))}
      </div>
      {secondary.length ? (
        <div className="flex gap-1 overflow-x-auto border-t border-border/60 px-2 py-1.5">
          {secondary.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  "shrink-0 rounded-full px-2.5 py-1 text-[11px]",
                  isActive
                    ? "bg-brand-muted text-brand"
                    : "bg-bg-card text-fg-muted",
                )
              }
            >
              {label}
            </NavLink>
          ))}
        </div>
      ) : null}
    </nav>
  );
}
